import { useMutation } from '@apollo/client/react';
import { notify } from '@components/ui/molecules/Toast';
import { RequestPasswordResetDocument } from '@graphql/types';
import { useCallback } from 'react';

import type { ReqPasswordResetResponse } from '../types';

export const useReqPasswordReset = () => {
  const [requestPasswordResetMutation, { loading }] = useMutation(RequestPasswordResetDocument);

  const doRequestPasswordReset = useCallback(
    async (email: string): Promise<ReqPasswordResetResponse> => {
      const response = await requestPasswordResetMutation({
        variables: { email },
      });
      const passwordResetRes = response.data?.requestPasswordReset;

      if (!passwordResetRes) {
        notify.error({ title: 'Change password failed', description: 'No response from server' });
        throw new Error('Request to reset password failed');
      }

      if (!passwordResetRes.emailSent) {
        notify.error({ title: 'Failed to send the email', description: passwordResetRes.message });
      } else {
        notify.success({
          title: 'Reset link sent successfully',
          description: 'If this email is registered, you will receive a reset link shortly.',
        });
      }
      
      return passwordResetRes as ReqPasswordResetResponse;
    },
    [requestPasswordResetMutation]
  );

  return { doRequestPasswordReset, loading };
};
